import {useFileApi} from "../context/ApiContext.tsx";
import {NotificationType, useNotification} from "../context/NotificationContext.tsx";
import {handleDownload, handleView} from "../filehelper/fileutils.ts";

export enum FileDownloadType {
    APPRAISER_PROFILE,
    APPRAISAL_FILE,
    GENERAL_FILE
}

export const FileViewer = ({ fileId, fileIs }: { fileId: number, fileIs: FileDownloadType }) => {
    const fileApi = useFileApi();

    const { showNotification } = useNotification();

    const getAndHandleDownload = async () => {
        try {
            const download = await fileApi.downloadFile(fileId, fileIs);
            await handleDownload(download);
        } catch (error) {
            console.error('Failed to download file:', error);
            showNotification(NotificationType.ERROR, 'Failed to download the file');
        }
    };


    const getAndHandleView = async () => {
        try {
            const download = await fileApi.downloadFile(fileId, fileIs);
            await handleView(download);
        } catch (error) {
            console.error('Failed to view file:', error);
            showNotification(NotificationType.ERROR, 'Failed to view the file');
        }
    };

    return (
        <div className="flex space-x-2">
            <button
                onClick={getAndHandleView}
                className="px-3 py-1 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 hover:cursor-pointer"
            >
                View
            </button>
            <button
                onClick={getAndHandleDownload}
                className="px-3 py-1 text-sm bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 hover:cursor-pointer"
            >
                Download
            </button>
        </div>
    );
};